import React, { Suspense, lazy } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Loader2, SmilePlus } from "lucide-react";
import { useApp } from "../context/AppContext";

const Picker = lazy(() => import("emoji-picker-react"));

/** Full emoji picker (search, categories, skin tones, recents) — used for "any emoji" reactions. */
export function EmojiPickerDialog({ open, onClose, onPick, zClass = "z-[300]" }) {
  const { t, lang } = useApp();
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className={`max-w-sm p-3 ${zClass}`} data-testid="emoji-picker-dialog" onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader className="pb-1">
          <DialogTitle className="font-display text-base flex items-center gap-2"><SmilePlus className="h-4 w-4" /> {t("pick_emoji")}</DialogTitle>
        </DialogHeader>
        <Suspense fallback={<div className="flex justify-center py-16"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>}>
          <Picker
            onEmojiClick={(e) => { onPick(e.emoji); onClose(); }}
            width="100%"
            height={380}
            lazyLoadEmojis
            skinTonesDisabled={false}
            searchPlaceholder={t("search")}
            previewConfig={{ showPreview: false }}
            emojiStyle="native"
            theme={document.documentElement.classList.contains("dark") ? "dark" : "light"}
            locale={lang === "pt" ? "pt" : lang === "es" ? "es" : "en"}
          />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
}
